<template>
  <custom-callout :has-toggle="false" class="mt-2" border-color="gray">
    <div :class="['row', { 'px-2': isMobile }]">
      <div class="col-12 pl-2">
        <div :class="['row pb-3', { 'pt-3': !isMobile, 'pt-1': isMobile }]">
          <div class="col-md-2 col-6 pt-0">
            <div>
              <div class="row">
                <div class="col-12 pt-0">
                  <span class="result-label">Nombre:</span>
                  <div class="regular text-black">
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2 col-6 pt-0">
            <div>
              <div class="row">
                <div class="col-12 pt-0">
                  <span class="result-label">Año Académico</span>
                  <div class="regular text-black">
                    {{ item.academicYearDescription || '-' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="item.rangeMaximumValue && item.rangeMinimumValue"
            :class="['col-md-2 col-6', isMobile ? 'pt-2' : 'pt-0']"
          >
            <div>
              <div class="row">
                <div class="col-12 pt-0">
                  <span class="result-label">Valor Mínimo Rango:</span>
                  <div class="regular text-black">
                    {{ item.rangeMinimumValue }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="item.rangeMinimumValue && item.rangeMaximumValue"
            :class="['col col-6', isMobile ? 'pt-2' : 'pt-0']"
          >
            <div>
              <div class="row">
                <div class="col-12 pt-0">
                  <span class="result-label">Valor Máximo Rango:</span>
                  <div class="regular text-black">
                    {{ item.rangeMaximumValue }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="item.value"
            :class="['col col-6', isMobile ? 'pt-2' : 'pt-0']"
          >
            <div>
              <div class="row">
                <div class="col-12 pt-0">
                  <span class="result-label">Valor Estático:</span>
                  <div class="regular text-black">
                    {{ item.value }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          :class="[
            'row divider-horizontal ',
            { 'pb-3 pt-3': !isMobile, 'pt-2': isMobile },
          ]"
        >
          <div class="col-6 col-md-3 pt-0">
            <div class="row">
              <div :class="['col-12', { 'pt-0': !isMobile, 'pt-1': isMobile }]">
                <span class="result-label">Descripcion:</span>
                <div class="regular text-black">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 col-md-2 pt-0">
            <div class="row">
              <div :class="['col-12', { 'pt-0': !isMobile, 'pt-1': isMobile }]">
                <span class="result-label">Creado</span>
                <div class="regular text-black">
                  {{ item.createdByFullName }}
                </div>
                <div class="regular text-black">
                  {{ formatDate(item.createdDate) }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-2 pt-0">
            <div class="row">
              <div :class="['col-12', { 'pt-0': !isMobile, 'pt-1': isMobile }]">
                <span class="result-label">Modificado por:</span>
                <div class="regular text-black">
                  {{ item.modifyByFullName }}
                </div>
                <div class="regular text-black">
                  {{ formatDate(item.modifydDate) }}
                </div>
              </div>
            </div>
          </div>

          <div
            :class="[
              'col-12 col-md-5',
              { 'pr-4 pt-3': isMobile, 'pl-2 pr-5': !isMobile },
            ]"
          >
            <div :class="isMobile ? '' : 'float-right'">
              <ActionButton
                class="btn-extra"
                i="fas fa-file-import pr-1 mt-2"
                variant="outline-success btn-transparent"
                @click="editSchool(item.id)"
              >
                Entrar
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import moment from 'moment';

const EDIT_SYS_PARAM_ROUTE_NAME = 'createEditSystemParameter';

export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    ActionButton,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    editSchool(sysParamId) {
      this.$router.push({
        name: EDIT_SYS_PARAM_ROUTE_NAME,
        params: {
          id: sysParamId,
        },
      });
    },
    formatDate(date) {
      if (date == null) return;
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY')
        .replace('.', '');
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
};
</script>

<style scoped>
.btn-transparent:not(:hover) {
  background-color: transparent !important;
}
.outline-success:hover {
  color: #fff;
  background-color: #2db782 !important;
}
.regular.text-black {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.result-label {
  color: #727272;
  font-weight: 500;
  font-size: small;
}
.prc {
  padding-right: 16%;
}

.divider-horizontal:after {
  content: '';
  position: absolute;
  left: 49%;
  margin-left: -48%;
  width: 96%;
  height: 1px;
  background: #b5c3bc;
  margin-top: -10px;
}

.col.p-2.ml-2 {
  margin-right: 0.5rem !important;
}

@media only screen and (max-width: 375px) {
  .regular.text-black {
    white-space: normal;
    font-size: 12px;
  }

  .result-label {
    font-size: 12px;
  }

  .btn-extra {
    position: initial !important;
    width: 100% !important;
  }

  ::v-deep .divider-horizontal::after {
    margin-left: -50%;
  }
}

.btn-extra {
  width: 120px;
  position: relative;
  bottom: 75px;
}
</style>
